import React, { useState, useMemo } from 'react';
import './GundamCard.scss';
import { removeDomainName } from '../../../helper';

const GundamCard = ({ product }) => {
  const defaultImage = product?.imageUrls?.[0];
  const hoverImage = product?.hover_image_url;

  // Current image
  const [currentImage, setCurrentImage] = useState(defaultImage);

  // Display price
  const displayPrice = product?.pricesV2?.find(p => p.name.toLowerCase() === 'lenskart price')
    ?.price
    ? `S$${product.pricesV2.find(p => p.name.toLowerCase() === 'lenskart price').price}`
    : '';

  // FallbackUrl
  const fallbackUrl = useMemo(() => {
    const rawPath = removeDomainName(product?.product_url || '').replace(/^\/+/, '');
    return rawPath.startsWith('sg/en/') ? `/${rawPath}` : `/sg/en/${rawPath}`;
  }, [product?.product_url]);

  // Handle view click
  const handleViewClick = () => {
    setCurrentImage(defaultImage);
    window.open(fallbackUrl, '_self');
  };

  // Product is eyeglasses (Lens included)
  const isEyeglasses = product?.type.toLowerCase() === 'eyeglasses';

  return (
    <div
      className="gundam-slider-card"
      onMouseEnter={() => setCurrentImage(hoverImage)}
      onMouseLeave={() => setCurrentImage(defaultImage)}
    >
      <div
        className={`gundam-slider-card__image__wrapper ${
          product?.modelNumber === 'ZAKU-CASE3A' ? 'gundam-slider-card__image__wrapper__zaku' : ''
        }`}
      >
        <img
          alt={product?.brand_name_en}
          className="gundam-slider-card__image"
          loading="lazy"
          src={currentImage || defaultImage}
        />
      </div>
      <div className="gundam-slider-card__details">
        <h5 className="gundam-slider-card__title">{product?.brand_name_en}</h5>
        {isEyeglasses && <p className="gundam-slider-card__subtitle">Lens Included</p>}
        <div className="gundam-slider-card__price-wrapper">
          <p className="gundam-slider-card__price">{displayPrice}</p>
          <button
            className="gundam-slider-card__btn odButton odButton--primary"
            onClick={handleViewClick}
          >
            VIEW
          </button>
        </div>
      </div>
    </div>
  );
};

export default GundamCard;
